import { useState } from 'react';
import { useScrollPosition } from '@/hooks/useScrollPosition';

const navLinks = [
  { label: 'Inicio', href: '#home' },
  { label: 'Nosotros', href: '#about' },
  { label: 'Servicios', href: '#services' },
  { label: 'Contacto', href: '#contact' },
];

export default function Navbar() {
  const { isScrolled } = useScrollPosition();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-biodata-dark/90 backdrop-blur-lg border-b border-biodata-teal/10 shadow-lg shadow-biodata-teal/5'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo - Analitica sin fondo */}
          <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center group">
            <img
              src="https://public.readdy.ai/ai/img_res/87cfbee4-5cd7-4011-9381-9833a6e5572a.png"
              alt="ANALITICA - Biological Sciences & Applied Research"
              className="h-8 md:h-9 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-sm text-biodata-muted hover:text-biodata-teal transition-colors relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-biodata-teal group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-biodata-teal/10 border border-biodata-teal/30 text-biodata-teal text-sm font-medium hover:bg-biodata-teal hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              <span>Agendar consulta</span>
              <i className="ri-arrow-right-line text-sm" />
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-biodata-dark/95 backdrop-blur-xl border-t border-biodata-teal/10">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="block text-biodata-muted hover:text-biodata-teal transition-colors py-2"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="block w-full text-center px-5 py-3 rounded-full bg-biodata-teal text-white text-sm font-medium mt-4 whitespace-nowrap"
            >
              Agendar consulta
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}